import { FormatNumber } from '../../../../../_config/functions/format-number.function';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';

export const formatPrice = (value) => {
	return FormatNumber[Enviroment.COUNTRY].handleFormat(value);
};
